import React, { useContext, useEffect, useState } from 'react'
import { Avatar, Button, Upload, UploadFile, UploadProps, message } from 'antd'

import editBlue from 'assets/images/edit-blue.png';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import InputBorderNone from '../../../../../components/BorrowerTask/components/Atoms/Inputs/InputBorderNone/InputBorderNone';
import { useUpdateOwnership } from '../../../../../services/ownership/mutations';
import { formatterPhone } from '../../../../../utils/formatters/formatter';

interface Props {
  _id: string;
  name?: any;
  lastName?: any;
  lastname?: any;
  email?: any;
  avatar?: any;
  phone?: any;
  __typename?: any;
}

const CardProfile = (borrower: Props) => {

  const { execute: updateOwnership, fetching: loadingUpdate } = useUpdateOwnership();

  const [fileAvatar, setFileAvatar] = useState<UploadFile>();
  const [isEdit, setEdit] = useState(false);
  const [previewAvatar, setPreviewAvatar] = useState();
  const [editName, setEditName] = useState();
  const [editLastname, setEditLastname] = useState();
  const [editEmail, setEditEmail] = useState();
  const [editPhone, setEditPhone] = useState();

  const handlePhoneChange = (e: any) => {
    const value = e.target.value;
    const cleaned = value.replace(/\D/g, '');

    if (cleaned.length <= 10) {
      setEditPhone(cleaned);
    }
  };

  useEffect(() => {
    if (!fileAvatar) {
      setPreviewAvatar(undefined)
      return
    }

    const objectUrl = URL.createObjectURL(fileAvatar as any)
    setPreviewAvatar(objectUrl as any)

    return () => URL.revokeObjectURL(objectUrl)
  }, [fileAvatar])

  const onClickEdit = () => {
    if (isEdit) {
      let payload: any = {
        _id: borrower?._id,
        name: editName || borrower?.name,
        lastname: editLastname || borrower?.lastName,
        email: editEmail || borrower?.email,
        phone: editPhone ? formatterPhone(editPhone) : borrower?.phone,
      };

      if (fileAvatar)
        payload.avatar = fileAvatar;

      updateOwnership(payload as any);
      setPreviewAvatar(undefined);
      setFileAvatar(undefined);
    }

    setEdit(!isEdit);
  }

  const props: UploadProps = {
    beforeUpload: (file) => {
      setFileAvatar(file);
      return false;
    },
    maxCount: 1,
    showUploadList: false,
  };

  const uploadButton = (
    previewAvatar ?
      <Avatar src={previewAvatar} size={68} className='avatar' />
      :
      <button style={{ border: 0, background: 'none' }} type="button">
        <PlusOutlined />
      </button>
  );

  return (
    <div className='card-profile-generic flex-btw gap-3'>
      <div className='flex-btw gap-3'>

        {!isEdit &&
          <Avatar src={!loadingUpdate && borrower?.avatar?.url} size={68} className='avatar'>
            {!borrower?.avatar && borrower?.name?.charAt(0)}
            {(loadingUpdate) && <LoadingOutlined />}
          </Avatar>
        }

        {isEdit &&
          <Upload
            name="avatar"
            listType="picture-circle"
            className="avatar"
            {...props}
          >
            {uploadButton}
          </Upload>
        }
        <div className='body'>
          {!isEdit &&
            <>
              <h1 className='card-title'>{borrower?.name + ' ' + borrower?.lastname}</h1>
              <h5 className='title-normal mt-5'>{borrower?.email}</h5>
            </>
          }
          {isEdit &&
            <div>
              <InputBorderNone
                color="bold-lith"
                placeholder="Name"
                onChange={(e: any) => setEditName(e.target.value)}
                defaultValue={borrower?.name}
              />
              <InputBorderNone
                color="bold-lith"
                placeholder="Lastname"
                onChange={(e: any) => setEditLastname(e.target.value)}
                defaultValue={borrower?.lastname}
                className="mt-5"
              />
              <InputBorderNone
                color="bold-lith"
                placeholder="Email"
                onChange={(e: any) => setEditEmail(e.target.value)}
                defaultValue={borrower?.email}
                className="mt-5"
              />
              <InputBorderNone
                color="bold-lith"
                placeholder="Phone"
                onChange={handlePhoneChange}
                value={editPhone !== undefined ? formatterPhone(editPhone) : (borrower?.phone ? formatterPhone(borrower.phone) : '')}
                onKeyDown={(e: any) => {
                  // Only allow numbers, backspace, delete, and arrow keys
                  if (!/[0-9]/.test(e.key) &&
                    e.key !== 'Backspace' &&
                    e.key !== 'Delete' &&
                    e.key !== 'ArrowLeft' &&
                    e.key !== 'ArrowRight' &&
                    e.key !== 'Tab') {
                    e.preventDefault();
                  }
                }}
                className="mt-5"
              />
            </div>
          }
          {!isEdit && <h5 className='title-normal mt-5'>{borrower?.phone ? formatterPhone(borrower.phone) : borrower?.phone}</h5>}
          {/* <Button className='button button-round mt-15'>{borrower?.__typename?.toUpperCase()}</Button> */}
        </div>
      </div>
      <Button className='button button-transparent button-edit' onClick={onClickEdit}>
        <img src={editBlue} className='edit' alt='edit' />
        {isEdit ? 'SAVE' : 'EDIT'}
      </Button>
    </div>
  )
}

export default CardProfile